/* -------------------------------------------------------------------------- */
/*                         VideoPlayerStats                                 */
/* -------------------------------------------------------------------------- */

import React from 'react';
import { useIntl } from 'react-intl';
import { Card, CardBody } from 'reactstrap';

interface VideoPlayerStats {
  totalBytes?: number;
}

interface Props {
  stats: VideoPlayerStats;
}

const VideoPlayerStats: React.FC<Props> = ({ stats }) => {
  const intl = useIntl();

  const formatBytes = (bytes?: number): string => {
    if (!bytes) return '0 B';
    if (bytes >= 1024 * 1024 * 1024) {
      return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`;
    }
    if (bytes >= 1024 * 1024) {
      return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    }
    if (bytes >= 1024) {
      return `${(bytes / 1024).toFixed(1)} KB`;
    }
    return `${bytes} B`;
  };

  return (
    <Card className="border-light shadow-sm">
      <CardBody className="py-2">
        {stats.totalBytes !== undefined && (
          <div>
            <small className="text-muted">{intl.formatMessage({ id: 'units.videoPlayer.totalData' })}</small>
            <div className="font-weight-bold mt-1">
              {formatBytes(stats.totalBytes)}
            </div>
          </div>
        )}
      
      </CardBody>
    </Card>
  );
};

export default VideoPlayerStats;